import $http from "@/helpers/http";
import Logger from "@/helpers/logger";

class UserApi {
  updateConfig(payload) {
    try {
      return $http.post("panel/user/update-config", payload);
    } catch (e) {
      Logger.error("`updateConfig` api", e);
      return Promise.reject(e);
    }
  }
}

const userApi = new UserApi();

export default userApi;
